import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import classNames from 'classnames/bind';
import { notification } from 'antd';
import { getContentMargins } from 'components/hoc/index';
import { socketPrefix, baseUrl } from 'config/env.config';
import Echo from 'laravel-echo';
import createSocket from 'utils/socketConnect';
import EnumsManager from 'utils/EnumsManager';
import { getAuthorization } from 'utils/common';
import { getStore } from 'utils/localStorage';
import { UNAUTHENTICATION } from 'config/app.config';
import allInfos from 'i18n/global/info';
import { deRegisterLoginUser } from 'views/LoginForm/flow/actions';
import {
  fetchAccountPermission,
  fetchGlobalSetting,
  fetchLoginUserDetail
} from 'store/global/action';
import { CopyRight, TopPanel } from '../page/index';
import styles from './layout.less';
import SetupLayout from './setupLayout';
import SubMainLayout from './subMainLayout';

// Extend Echo
// TODO: resolve coupling
/**
 * @param {Number} userId current user id
 */
Echo.prototype.isPrivateChannelExists = function isPrivateChannelExists(userId) {
  return _.isObject(this.channel(`private-${socketPrefix}.user-${userId}`));
};
/**
 * @param {Number} userId current user id
 * @param {String} eventName
 */
Echo.prototype.isListenerExists = function isListenerExists(userId, eventName) {
  if (!this.isPrivateChannelExists(userId)) return false;

  const channel = this.channel(`private-${socketPrefix}.user-${userId}`);
  if (!channel) return false;

  return !_.isNil(channel.events && channel.events[eventName]);
};
/**
 * @param {Number} userId current user id
 * @param {String} eventName
 * @param {Function} callback
 */
Echo.prototype.addPrivateChannel = function addPrivateChannel(
  userId,
  eventName,
  callback
) {
  // TODO: validate params
  // bind the callback function and make it always new.
  this.callback = callback;
  // Skip new listener if the same listener is existed
  if (this.isListenerExists(userId, eventName)) return;

  return this.private(`${socketPrefix}.user-${userId}`).listen(
    `.${eventName}`,
    data => this.callback(data)
  );
};

const cx = classNames.bind(styles);

class MainLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasTokenChecked: false,
      isTokenValid: false,
    };
  }

  async componentDidMount() {
    await this.checkUserToken();

    if (!this.state.isTokenValid) {
      return;
    }

    const {
      dispatchFetchGlobalSetting,
      dispatchFetchAccountPermission,
      dispatchFetchLoginUserDetail
    } = this.props;
    const localLoginUser = getStore(EnumsManager.LocalStorageKey);
    if (!_.isEmpty(localLoginUser)) {
      dispatchFetchGlobalSetting();
      dispatchFetchAccountPermission();
      dispatchFetchLoginUserDetail();
    }
  }
  componentWillUnmount() {
    if (_.isObject(window.Echo)) {
      window.Echo.disconnect();
    }
  }

  hasLoggedIn = () => {
    // we'll check the login status in localstorage instead of redux/session storage
    // because it will help us to sync the status across application instances

    const { loginUser } = this.props;
    const localLoginUser = getStore(EnumsManager.LocalStorageKey);
    if (_.isEmpty(localLoginUser)) {
      return false;
    }
    return !_.isEmpty(loginUser) && this.state.isTokenValid;
  };

  isForceLogout = () => {
    const { errors } = this.props;
    const forceLogout = errors.errors.filter(item => item.forceLogout);

    return Array.isArray(forceLogout) &&
      !!forceLogout.length &&
      forceLogout[0] &&
      forceLogout[0].forceLogout;
  }

  isEchoInited = () => _.isObject(window.Echo);
  initSocketIfNeeded = () => {
    if (this.isEchoInited()) return;

    createSocket();
  };

  checkUserToken = async () => {
    try {
      const accessToken = getAuthorization();

      if (!accessToken) {
        this.invalidateSession();
        return;
      }

      const apiUrl = `${baseUrl}/admin/me`;
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          Authorization: accessToken,
        }
      });

      if (response.status === UNAUTHENTICATION.CODE) {
        this.invalidateSession();
        return;
      }

      if (!response.ok) {
        this.notifyNetworkError();
      }
    } catch (error) {
      this.notifyNetworkError();
    }

    this.setState({ hasTokenChecked: true, isTokenValid: true });
  }

  notifyNetworkError = () => {
    notification.error({
      message: allInfos[window.globalLanguage].networkError,
    });
  }

  invalidateSession = () => {
    const { dispatchDeRegisterLoginUser } = this.props;
    dispatchDeRegisterLoginUser(window.location.pathname !== '/auth/login' ? window.location.pathname : '');
    this.setState({ hasTokenChecked: true, isTokenValid: false });
  }

  render() {
    if (!this.state.hasTokenChecked) {
      return null;
    }

    // Init web socket
    this.initSocketIfNeeded();

    // TODO: Skip the login if in dev mode
    // const isDevMode = process.env.NODE_ENV === 'development' ? true : false;
    const { location, margins } = this.props;

    return (
      <div>
        {this.isForceLogout() || !this.hasLoggedIn() ? (
          <Redirect to="/auth/login" />
        ) : (
          <div className={cx('body-wrapper')}>
            <div className={cx('header-wrapper')}>
              <TopPanel nextPath={location.pathname} />
            </div>
            <Switch>
              <Route path="/setup" component={SetupLayout} />
              <Route path="/" component={SubMainLayout} />
            </Switch>
            <div className={cx('footer-wrapper')} style={margins}>
              <CopyRight />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ loginUser, errors }) => ({
  loginUser,
  errors
});
const mapDispatchToProp = {
  dispatchFetchGlobalSetting: fetchGlobalSetting,
  dispatchFetchAccountPermission: fetchAccountPermission,
  dispatchFetchLoginUserDetail: fetchLoginUserDetail,
  dispatchDeRegisterLoginUser: deRegisterLoginUser
};
export default withRouter(getContentMargins(connect(
  mapStateToProps,
  mapDispatchToProp
)(MainLayout)));



// WEBPACK FOOTER //
// ./src/components/layout/mainLayout.js